import $ from 'jquery';

$('.site-header').toggleItem({
  button: '.site-header__nav-toggle',
  buttonActiveClass: 'icon-button--toggle',
  content: '.site-header__primary-nav, .site-header__secondary-nav',
  closeOnBlur: true
});

